import { reactive } from 'vue'
import { Module } from 'vuex'
import User from '../models/user'
import api from '../../api/v2/api'
import { ApiError } from '../../api/v2/api/base/response'
import UserForm from '../../api/v2/forms/user_form'

class UserState {
  user: User | null = null
  isLoading = false
  errorMessage = ''

  setErrorMessage(errorMessage) {
    this.errorMessage = errorMessage
  }

  async getUser() {
    try {
      this.isLoading = true
      this.errorMessage = ''
      this.user = await api.user.get()
    } catch (error) {
      console.error('Failed to get user:', error)
      this.errorMessage = error instanceof ApiError ? error.messages : 'Unknow Error'
    } finally {
      this.isLoading = false
    }
  }

  async updateUser({ userForm }: { userForm: UserForm }) {
    try {
      this.isLoading = true
      this.errorMessage = ''
      userForm.currentPath = location.href
      await api.user.patch(userForm)
      this.isLoading = false
      await this.getUser()
    } catch (error) {
      this.isLoading = false
      this.errorMessage = error instanceof ApiError ? error.messages : 'Unknow Error'
    } finally {
    }
  }

  async updateLearnTimeGoalValue({ learnTimeGoalValue }: { learnTimeGoalValue: number }) {
    try {
      this.isLoading = true
      this.errorMessage = ''
      this.user = await api.user.updateLearnTimeGoalValue(learnTimeGoalValue)
      this.isLoading = false
    } catch (error) {
      this.isLoading = false
      this.errorMessage = error instanceof ApiError ? error.messages : 'Unknow Error'
    } finally {
    }
  }
}

// Wrap in reactive() for Vue 3 reactivity
export const userState = reactive(new UserState()) as UserState
